import { useReducer } from 'react';
const DepositsVerificationState = (props) => {
    const initialState = {
        step: 0,
        deposit: undefined,
        walletType: undefined,
        ownerType: undefined,
    };
    const reducer = (state = initialState, action) => {
        switch (action.type) {
            case 'INIT':
                return Object.assign(Object.assign({}, state), { deposit: action.payload.deposit });
            case 'UPDATE_STEP':
                return Object.assign(Object.assign({}, state), { step: action.payload.step });
            case 'SET_WALLET_TYPE':
                return Object.assign(Object.assign({}, state), { walletType: action.payload.walletType });
            case 'SET_PERSON_TYPE':
                return Object.assign(Object.assign({}, state), { ownerType: action.payload.ownerType });
            default:
                return state;
        }
    };
    const [state, dispatch] = useReducer(reducer, initialState);
    return { state, dispatch };
};
export default DepositsVerificationState;
